export default {
	name: 'gpdr',
	store() {
		return {
			isSlideoutOpened: false,
			shouldShowBanner: true
		}
	}
}
